import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../../__root";

export const authOtpConfirmationsNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/otp_confirmations/new",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "OtpConfirmationPage" */ "@circle-react/components/OnboardingPage/OtpConfirmationPage"
      ),
    "OtpConfirmationPage",
  ),
});
